module.exports = __webpack_public_path__ + "static/img/n17.b7d7741.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/resourceShow/img/zh/n17.png
// module id = ksaL
// module chunks = 3